import 'whatwg-fetch'
import Auth from './Auth'
import Url from 'url-parse'
import axios from 'axios'
import qs from 'qs'
import { saveAs } from 'file-saver'
import { sleep } from 'utils'
import _ from 'lodash'

const API_URL = process.env.API_URL

const http = {
  get: get,
  getAuthed: getAuthed,
  post: post,
  postAuthed: postAuthed,
  getDefaultHeaders: getDefaultHeaders,
  getApiUrl: getApiUrl,
  getApplicationUrl: getApplicationUrl,
  getAuthHeaders: getAuthHeaders,
  downloadFile: downloadFile,
  sleep: sleep,
  paramsToQuerystring,
}
window.http = http
export default http

function post(url, data, extraHeaders, opts) {
  extraHeaders = extraHeaders || {}
  opts = opts || {}
  const request = performRequest(url, {
    method: 'POST',
    headers: mergeHeaders(getDefaultHeaders(), extraHeaders),
    data: data,
    // body: JSON.stringify(data),
  })
  return request
}

function get(url, extraHeaders, params) {
  extraHeaders = extraHeaders || {}
  params = params || {}
  const request = performRequest(url, {
    method: 'GET',
    headers: mergeHeaders(getDefaultHeaders(), extraHeaders),
    params,
    paramsSerializer(params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  })
  return request
}

function getAuthed(url, params) {
  return get(url, getAuthHeaders(), params)
}

function postAuthed(url, data, opts) {
  return post(url, data, getAuthHeaders(), opts)
}

function getAuthHeaders() {
  const token = Auth.getAuthToken()
  if (token) {
    return { Authorization: `Token ${token}` }
  } else {
    return {}
  }
}

const defaultOptions = {
  validateStatus: (status) => {
    // reject only if status is >= 500
    return status < 400
  },
}

function performRequest(url, opts) {
  opts = opts || {}
  opts = Object.assign({}, defaultOptions, opts)
  const isFullUrl = /^\w+:\/\//.test(url)
  if (!isFullUrl) {
    url = getApiUrl(url)
  }
  opts.url = url
  return axios(opts)
}

export function getApiUrl(url) {
  var parsedUrl = new Url(url)
  if (parsedUrl.href !== url) {
    url = urljoin(API_URL, url)
  }
  return url
}

export function getApplicationUrl(url) {
  // returns full url for the application
  var parsedUrl = new Url(url)
  if (parsedUrl.href !== url) {
    url = urljoin(getBaseApplicationUrl(), url)
  }
  return url
}

function getBaseApplicationUrl() {
  const url = new Url(window.location.href)
  return url.origin
}

function isPath(url) {
  const parsed = new Url(url)
  // console.log(" => isPath parsed:", parsed);
  return !parsed.protocol
}

function urljoin(baseUrl, path) {
  if (baseUrl && baseUrl[baseUrl.length - 1] === '/') {
    baseUrl = baseUrl.slice(0, baseUrl.length - 1)
  }
  if (path && path[0] === '/') {
    path = path.slice(1)
  }
  return [baseUrl, path].join('/')
}

function mergeHeaders(defaultHeaders, headers) {
  var result = Object.assign({}, defaultHeaders, headers)
  for (const key in headers) {
    if (headers[key] === null) {
      delete result[key]
    }
  }
  return result
}

function getDefaultHeaders() {
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
}

async function downloadFile(urlPath, fileName, filters = {}) {
  let url = http.getApiUrl(urlPath)
  const querystring = http.paramsToQuerystring(filters)
  if (querystring) {
    url = `${url}?${querystring}`
  }
  let opts
  const appUrl = getBaseApplicationUrl()
  if (url.startsWith(appUrl) || url.startsWith(API_URL)) {
    opts = { headers: getAuthHeaders() }
  }
  const response = await fetch(url, opts)
  if (response.status !== 200) {
  }
  const blob = await response.blob()
  saveAs(blob, fileName)
}

function DownloadError(response, ...params) {
  const instance = new Error(...params)
  instance.response = response
  return instance
}

function paramsToQuerystring(params) {
  return _.toPairs(params)
    .filter((pair) => {
      const [key, values] = pair
      if (_.isArray(values)) {
        return values.length > 0
      } else {
        return values !== undefined && values !== null
      }
    })
    .map((pair) => {
      let [key, values] = pair
      if (!_.isArray(values)) {
        values = [values]
      }
      return values.map((val) => [key, val].join('=')).join('&')
    })
    .join('&')
}
